export default {
  gameHome: {
    title: "客服中心",
    componentPath: "game/GameHome"
  },
  appealSubmit: {
    title: "账号申诉",
    componentPath: "appeal/AppealSubmit"
  },
  appealFind: {
    title: "申诉查询",
    componentPath: "appeal/AppealFind"
  },
  ask: {
    title: "我要提问",
    requiresAuth: true,
    componentPath: "game/Ask"
  },
  // back: {
  //   title: "被盗找回",
  //   requiresAuth: true,
  //   componentPath: "game/Back"
  // },
  lading: {
    title: "我的提单",
    requiresAuth: true,
    componentPath: "game/myLading/MyLading"
  },
  // tel: {
  //   title: "客服电话",
  //   componentPath: "Tel"
  // },
  clearLock: {
    title: "清除密码锁",
    requiresAuth: true,
    componentPath: "game/ClearLock"
  },
  lockAccount: {
    title: "账号",
    requiresAuth: true,
    componentPath: "game/lockAccount/LockAccount"
  }
};
